const apiURLs = {
  face: `https://sharkadoodle-beam-wake.sharkadoodle-wake.workers.dev/face`,
  body: `https://sharkadoodle-beam-wake.sharkadoodle-wake.workers.dev/full`,
};

const apiUserChoiceURLs = {
  face: `https://app.beam.cloud/asgi/sharkadoodle-style-face-only-v2/move_selected`,
  body: `https://app.beam.cloud/asgi/sharkadoodle-style-full-body-v2/move_selected`,
};

  
const pingURLs = {
  face: `https://sharkadoodle-style-face-only-8256783-v73.app.beam.cloud/ping`,
  body: `https://sharkadoodle-style-full-body-7f75f3d-v47.app.beam.cloud/ping`,
};

// Designs 
let previousSelectedDesign = null

// PingResponse
let pingData = null

// spinner
const totalDuration = 80000; // 60 seconds
const interval = 1000;       // 1-second interval
const increment = 100 / (totalDuration / interval);
const spinner = document.getElementById('spinner');
const spinnerContainer = document.getElementById('spinner-container');
const progressLabel = document.getElementById('progressLabel');
let progress = 0;
let timer;

// cart 

let addedCartLineItems = []


// form file input
const fileErrorMessage = document.getElementById('fileErrorMessage');
const submittedFiles = [];      

// submission results
let groupNumber = 0;
const maxGroups = 6;
const template = document.getElementById("image-template");
const imagesContainer = document.querySelector(".images");


const form = document.querySelector('[data-form="ai-design"]');
const approveButton = document.getElementById('approveButton');
const submitForm = document.getElementById('submitForm');
let fileInput = form.querySelector('input[type="file"]')

const myHeaders = new Headers({
  "Authorization": "Bearer wclFmmq7FMXAh1Qoi___OsXJyAd7u0B5wL4EbY-z0gbS33YR_cFNVXOOBY7NVzEcY59uTGRD5AtZsvgbUbzUTw==",
  "Content-Type": "application/json",
});

// Function to handle file reading and return a promise with the base64 string
function readFileAsBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result.split(",")[1]); // Resolve with the base64-encoded string
    reader.onerror = reject; // Reject in case of an error
    reader.readAsDataURL(file); // Start reading the file
  });
}

async function sendFormData(email, base64Images) {
  const body = JSON.stringify({
    email: email,
    encoded_images: base64Images,
  });

  const requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: body,
    redirect: "follow",
  };

  const apiURL = apiURLs[form.querySelector('#designType').value]
  const response = await fetch(apiURL, requestOptions);

  if (!response.ok) {
    throw new Error(`HTTP error! status: ${response.status}`);
  }

  return response.json(); // Return the parsed JSON result
}

function handleLoadMore(event) {
  let fileInput = form.querySelector('input[type="file"]');
  form.querySelector('#firstSubmit').style.visibility = 'hidden'
  form.querySelector('#secondSubmit').classList.remove('d-none');
  form.querySelector("#designType").disabled = false;
  document.getElementById('numberOfDogs').disabled = false
  form.querySelector("[data-section='load-more']").classList.add('d-none');
  form.querySelector("[data-section='different-photo-action']").classList.add('d-none')
  form.querySelector("[data-section='designer-work']").classList.remove('d-none')
  fileInput.value = ''
  form.querySelector('#designType').scrollIntoView({ behavior: "smooth", block: "center" });
  let submitButton = form.querySelector("button[type=submit]")
  submitButton.classList.remove("d-none");
}

async function handleApprove(event) {
    // document.querySelector("#chooseProduct").classList.remove("d-none");
    // document.querySelector("[data-section='accessory']").classList.remove("d-none");
    // submitForm.scrollIntoView({ behavior: "smooth", block: "center" });
    const productId = event.target.getAttribute('data-product-id');
    const selectNumberOfDogs = document.getElementById('numberOfDogs');
    const selectedNumberOfDogsValue = selectNumberOfDogs.value;
    const checkedRadios = document.querySelectorAll('input[type="radio"]:checked');

    numberOfDogs = parseInt(selectedNumberOfDogsValue)
    validFlag = (numberOfDogs == checkedRadios.length);
    if (!validFlag) {
      alert(`You must select ${numberOfDogs} image${(numberOfDogs == 1) ? '' : 's'}`);
      return;
    }
  
    let imagesPayload = []
    let imageURLs = []
    for (const radio of checkedRadios) {
        const imageKey = radio.id.replace(/[^0-9]/g, '');  // Extract numeric part from the radio id
        const img = document.querySelector(`img.options[data-image="${imageKey}"]`); 
        const aiImage = img.src;
        const formData = {
            'items': [{
                'id': productId,
                'quantity': 1,
                'properties': {
                  'aiImage': aiImage,
                  'numberOfDogs': selectedNumberOfDogsValue
                }
            }]
        }
        

        imageURLs.push(aiImage)
      
        try {
            const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(formData)
            });
            const responseData = await response.json();
            addedCartLineItems.push(responseData.items[0].key)
            imagesPayload.push({
              original: img.getAttribute('data-original'),
              watermarked: aiImage
            });

            // console.log(`Successfully added image ${aiImage} to the cart.`);
        } catch (error) {
          window.test = error
            console.error(`Error adding image ${aiImage}:`, error);
        }
    }
    localStorage.setItem('aiImageURLs', JSON.stringify(imageURLs));
    await saveUserChoice(apiUserChoiceURLs[form.querySelector('#designType').value], { images: imagesPayload });
    window.location = '/collections/all-products';
}


async function saveUserChoice(endpoint, data) {
    try {
        const response = await fetch(endpoint, {
            method: "POST",
            headers: myHeaders,
            body: JSON.stringify(data)
        });
        
        const responseData = await response.json();
        // console.log(responseData)
    } catch (error) {
        console.error("Network error:", error);
    }
}

async function goToCheckout(event) {
  window.location = '/collections/all-products';
}

async function addAccessoryAttribute(event) {
  event.preventDefault();
  const selectAccessoryElement = document.getElementById('acessoryType');
  const accessoryValue = selectAccessoryElement.value;
  
  // Fetch the cart data
  const cartResponse = await fetch('/cart.js', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });
  
  if (!cartResponse.ok) {
    console.error('Failed to fetch cart data');
    return;
  }
  
  const cartData = await cartResponse.json();

  // Iterate over the items and update them sequentially
  for (const lineItemKey of addedCartLineItems) {
    const item = cartData.items.find((i) => i.key === lineItemKey);
    
    if (!item) {
      console.log(`Item with key ${lineItemKey} not found in the cart.`);
      continue;
    }

    const updateData = {
      id: item.key,
      quantity: item.quantity,
      properties: {
        ...item.properties,
        accessory: accessoryValue, // Add or update the "accessory" attribute
      },
    };

    try {
      // Send request to update each item, and wait for the response to be completed before continuing
      const updateResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(updateData),
      });

      if (!updateResponse.ok) {
        throw new Error(`Failed to update item with key: ${item.key}`);
      }

      const updatedCart = await updateResponse.json();

    } catch (error) {
      console.error('Error updating cart:', error);
    }
  }

  window.location = '/collections/all-products';
}





function updateProgress() {
  progress = Math.min(progress + increment, 100);
  if (progress == 100) {
    return 
  }
  spinner.style.background = `conic-gradient(#4caf50 ${progress}%, #ddd ${progress}% 100%)`;
  progressLabel.textContent = `${Math.round(progress)}%`;
  if (progress < 100) {
    timer = setTimeout(updateProgress, interval);
  }
}

function finishProgressBar() {
    progress = 100
    progressLabel.textContent = `${Math.round(progress)}%`;
    spinner.style.background = `conic-gradient(#4caf50 ${progress}%, #ddd ${progress}% 100%)`;
}

function resetProgress() {
  progress = 0;
  spinner.style.background = `conic-gradient(#4caf50 0%, #ddd 0% 100%)`;
  progressLabel.textContent = '0%';
  spinnerContainer.classList.add("d-none");
  clearTimeout(timer);  
}

async function handleSubmit(event) {
  event.preventDefault();

  numberOfDogInput = document.getElementById('numberOfDogs')
  try {
    if (!numberOfDogInput.disabled) {
      numberOfDogInput.disabled = true
    }
    const fileInput = form.querySelector('input[type="file"]');
    const files = fileInput.files;

    if (files.length != numberOfDogInput.value) {
      fileErrorMessage.scrollIntoView({ behavior: "smooth", block: "center" });
      fileErrorMessage.classList.remove("d-none");
      return
    }
  
    const duplicates = Array.from(files).filter(file => submittedFiles.includes(file.name));
    if (duplicates.length > 0) {
      alert('We highly advise to choose another photo for second round')
      return 
    }
    submittedFiles.push(...Array.from(files).map(file => file.name))
    
    form.querySelectorAll("button[type=submit]").forEach((el) => { el.classList.add("d-none") });
    fileErrorMessage.textContent = '';

    const base64Images = [];

    for (const file of files) {
      const base64 = await readOrientedImageAsBase64(file);
      base64Images.push(base64);
    }
    spinnerContainer.classList.remove("d-none");
    setTimeout(updateProgress, interval);

  
    // Send the form data with email and base64-encoded image
    const email = form.email.value;
    // if (!pingData) {
        // console.log('Waiting for data to be fetched...');
        // while (!pingData) {
            // await new Promise(resolve => setTimeout(resolve, 100));
        // }
    // }


    const hubspotData = {
    fields: [
      { name: "0-1/email", value: email },
    ],
    context: {
      pageUri: window.location.href,
      pageName: document.title
      }
    };

     try {
      const hubspotResponse = await fetch('https://api.hsforms.com/submissions/v3/integration/submit/7927090/eaa764bc-5b3b-401f-831a-dad20c89ac86', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(hubspotData)
      });

      if   (hubspotResponse.ok) {
        console.log('HubSpot form submitted successfully.');
      } else {
        const errorData = await hubspotResponse.json();
        console.error('HubSpot submission error:', errorData);
      }
    } catch (error) {
      console.error('Network error:', error);
    }
    
    const result = await sendFormData(email, base64Images)

    finishProgressBar(100)
    await new Promise(resolve => setTimeout(resolve, 1000)); 
    
    let countStart = imagesContainer.lastElementChild.getAttribute("data-element-order") || 0
    let selectFirstDesign = countStart
    
    result.images.forEach((value) => {
      const imageIndex = ++countStart;

      // Create new group every 3 images
      if ((imageIndex - 1) % 3 === 0) { groupNumber++; }
    
      const newImageElement = template.cloneNode(true);
      newImageElement.removeAttribute('id');
      newImageElement.removeAttribute("class");
      newImageElement.setAttribute("data-element-order", imageIndex);

      const input = newImageElement.querySelector("input");
      input.id = `image${imageIndex}`;
      input.name = `image-group-${groupNumber}`; // Group name
      input.dataset.group = groupNumber;

      const img = newImageElement.querySelector("img");
      img.setAttribute("data-image", imageIndex);
      img.src = value.watermarked;
      img.setAttribute("data-original", value.original);
      imagesContainer.appendChild(newImageElement);
    });

    // console.log(selectFirstDesign)
    if (selectFirstDesign == 0) { 
      document.querySelector(".images").querySelectorAll('input[type="radio"]')[1].checked = true
    } else {
      // console.log(document.querySelector(".images").querySelectorAll('input[type="radio"]'))
      document.querySelector(".images").querySelectorAll('input[type="radio"]').forEach(radio => 
        radio.checked = false 
      )
    }
    document.querySelector("[data-section='load-more']").classList.remove("d-none");
    document.querySelector("[data-section='result']").classList.remove("d-none");
    document.querySelector(".images").style.display = "flex";
    form.querySelector("button[type=submit]").classList.add("d-none");
  } catch (error) {
    console.error("Error during form submission:", error);
  } finally {
    resetProgress()
  }
}

function readOrientedImageAsBase64(file) {
  return new Promise((resolve, reject) => {
    loadImage(
      file,
      function (canvas) {
        if (canvas.type === 'error') {
          reject(new Error('Image load failed'));
          return;
        }

        try {
          const dataUrl = canvas.toDataURL('image/jpeg', 0.9);
          const base64 = dataUrl.split(',')[1]; // Strip "data:image/jpeg;base64,"
          resolve(base64);
        } catch (e) {
          reject(e);
        }
      },
      {
        orientation: true,
        canvas: true,
        maxWidth: 1000,
        maxHeight: 1000
      }
    );
  });
}

// Add the submit event listener to the form
loadMore.addEventListener("click", handleLoadMore);
submitForm.addEventListener("click", goToCheckout)
approveButton.addEventListener("click", handleApprove);
form.addEventListener("submit", handleSubmit);
form.querySelector("#designType").addEventListener("change", handleSetDesignType);
imagesContainer.addEventListener("click", handleRadioSelection);
imagesContainer.addEventListener("click", deselectRadio);
const designTypeSelect = document.getElementById('numberOfDogs');
designTypeSelect.addEventListener('change', () => {
  // Select all checked radio buttons
  const checkedRadios = document.querySelectorAll('input[type="radio"]:checked');
  // console.log(checkedRadios)
  if (checkedRadios.length > 0) {
    checkedRadios.forEach(radio => {
      radio.checked = false;
    });
  }
});

function handleRadioSelection(event) {
  if (!event.target.matches("input[type='radio']")) return;
  const radio = event.target;
  const selectedRadios = document.querySelectorAll(".images input[type='radio']:checked");
  if (selectedRadios.length >= 3) {
    alert("You can select up to 3 variants only.");
    event.preventDefault(); 
  }
}

function deselectRadio(e) {
  const radio = e.target;
  const input = e.target.previousElementSibling;
  e.preventDefault(); 
  const group = input.dataset.group; // Group of the clicked radio button
  const selectedRadios = document.querySelectorAll(".images input[type='radio']:checked");
  const selectNumberOfDogs = document.getElementById('numberOfDogs');
  const groupSelectedRadios = document.querySelectorAll(`input[name="image-group-${group}"]:checked`);
  if (radio.tagName === "IMG" && radio.classList.contains("options")) {
    if (input && input.type === "radio") {
      // Toggle the checked state
      input.checked = !input.checked;
    }
  }

  if (selectedRadios.length >= selectNumberOfDogs.value && groupSelectedRadios.length === 0) {
    // alert("Please select the number of designs you specified earlier");
    previousSelectedDesign.checked = false;
  }

  if (selectedRadios.length > 3) {
    // alert("You can select up to 3 variants only.");
    previousSelectedDesign.checked = false;
  }

  previousSelectedDesign = input 
}


// Disable DesignType select and send pingRequest to ImageGenerator
function handleSetDesignType(event) {
  event.target.disabled = true;
  pingRequest(event.target.value)
}

async function pingRequest(target) {
  const requestOptions = {
    method: "GET",
    headers: myHeaders,
  };

  try {
    const response = await fetch(pingURLs[target], requestOptions);

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const data = await response.json();
    pingData = data;
    // console.log("Data fetched successfully:", data);
  } catch (error) {
    console.error("Error fetching data:", error);
  }
}
